import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import "../../index.css";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		status: "",
		token: localStorage.getItem("token") || "",
		user: {},
		error: {},
	},
	mutations,
	actions,
	getters,
});
